import DefaultLayout from "@/layouts/DefaultLayout";
import KForgotPasswordForm from "@/components/Auth/KPassword/KForgotPasswordForm";
import { VImg } from "vuetify/lib";

export default {
	name: "ForgotPasswordPage",

	metaInfo: { title: "Forgot Password" },

	render() {
		return <DefaultLayout maxWidth="320px">
			<VImg
				class="mb-3 mx-auto d-block"
				maxWidth={233}
				src={require( "@/assets/logos/logo.png" )}
			></VImg>

			<KForgotPasswordForm></KForgotPasswordForm>
		</DefaultLayout>;
	}
};
